export default "__VITE_ASSET__Cwn3v3mt__"